import(/* webpackMode: "eager" */ "/home/shehin/first-project/mykare-blog-web/app/global-error.tsx");
